import { render, staticRenderFns } from "./rides.vue?vue&type=template&id=237d218c&scoped=true&"
import script from "./rides.vue?vue&type=script&lang=js&"
export * from "./rides.vue?vue&type=script&lang=js&"
import style0 from "./rides.vue?vue&type=style&index=0&id=237d218c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237d218c",
  null
  
)

export default component.exports